import { atomEffect } from '@exodus/headless-ui';
import { fromAssetAtom, fromWalletAccountAtom, toAssetAtom, toWalletAccountAtom, } from '../atoms/index.js';
const assetRevalidationEffect = atomEffect((get, set, { selectors }) => {
    const availableAssetNamesByWalletAccount = get(selectors.assetSources.availableAssetNamesByWalletAccount);
    const fromWalletAccount = get(fromWalletAccountAtom);
    const toWalletAccount = get(toWalletAccountAtom);
    const fromAsset = get(fromAssetAtom);
    const toAsset = get(toAssetAtom);
    const fromAvailable = availableAssetNamesByWalletAccount[fromWalletAccount.toString()];
    if (fromAvailable && !fromAvailable.has(fromAsset.name))
        set(fromAssetAtom, undefined);
    const toAvailable = availableAssetNamesByWalletAccount[toWalletAccount.toString()];
    if (toAvailable && !toAvailable.has(toAsset.name))
        set(toAssetAtom, undefined);
});
export default assetRevalidationEffect;
